import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getItems } from '../../actions/item';
import { setLanguage } from '../../actions/language';
import { Helmet } from 'react-helmet';

import Spinner from '../layout/Spinner';
import NavbarHU from '../layout/NavbarHU';
import FooterHU from '../layout/FooterHU';
import ItemList from '../items/ItemList';
import ItemInfo from '../items/ItemInfo';

const Galeria = ({ getItems, setLanguage, item: { currentitem, items } }) => {
  useEffect(() => {
    getItems();
    setLanguage('hu');
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>Kínálatunk | Kárai Galéria</title>
      </Helmet>
      {currentitem && <ItemInfo lang={'hu'} />}
      <NavbarHU active='Galéria' />
      <section className='main-content-normal'>
        <div className='page-title'>
          <h1>Kínálatunkból</h1>
          <hr />
        </div>
        <div className='item-list'>
          {items.length > 0 ? <ItemList list={items} /> : <Spinner />}
        </div>
      </section>
      <FooterHU />
    </Fragment>
  );
};

Galeria.propTypes = {
  getItems: PropTypes.func.isRequired,
  setLanguage: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  item: state.item
});

export default connect(mapStateToProps, { getItems, setLanguage })(Galeria);
